export default "__VITE_ASSET__c58a633d__"